<template lang="html">
</template>

<script>
export default {
  beforeCreate(){
    this.$router.replace({name: 'hello'})
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// NotFound.vue?646b1304